import React, { useLayoutEffect, useRef } from 'react';

// LONGTEXT-PARTY-001 — single-value party/name fields that need 2–3 visible
// lines with wrapping. Visual only: stored value stays a single-line string
// (Enter is blocked, pasted line breaks collapse to spaces), grows vertically
// to MAX_PX then scrolls internally; never grows horizontally.
const MIN_PX = 64;
const MAX_PX = 160;

export const PartyTextarea = ({ value, onChange, className = '', ...rest }) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(Math.max(el.scrollHeight, MIN_PX), MAX_PX)}px`;
    el.style.overflowY = el.scrollHeight > MAX_PX ? 'auto' : 'hidden';
  }, [value]);

  return (
    <textarea
      ref={ref}
      rows={2}
      wrap="soft"
      className={`${className} resize-none break-words whitespace-pre-wrap leading-5`}
      style={{ minHeight: MIN_PX, maxHeight: MAX_PX }}
      value={value}
      onChange={e => {
        const raw = e.target.value;
        const flat = raw.replace(/\r?\n+/g, ' ');
        if (flat !== raw) e.target.value = flat;
        onChange(e);
      }}
      onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
      {...rest}
    />
  );
};

export default PartyTextarea;
